const config = {
   //APIDEV: "http://35.200.200.166", //local

  APIDEV: "https://hipship.com/",
  PINCODEURL: "https://api.postalpincode.in",
};

export default config;
